// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { BrowserRouter } from "react-router-dom";
import { NotificationProvider } from "./context/NotificationContext";
import { LoaderProvider } from "./context/LoaderContext";
import { AuthProvider } from "./context/AuthContext";
import { AvatarProvider } from "./context/AvatarContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import { GameProvider } from "./context/GameContext";

import "./app/index.css";
import "./assets/css/global.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // ❌ <React.StrictMode> supprimé
  <BrowserRouter>
    <AuthProvider>
      <AvatarProvider>
        <NotificationProvider>
          <LoaderProvider>
            <WebSocketProvider>
              <GameProvider>
                <App />
              </GameProvider>
            </WebSocketProvider>
          </LoaderProvider>
        </NotificationProvider>
      </AvatarProvider>
    </AuthProvider>
  </BrowserRouter>
);
